import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
    return (
        <div
            data-testid="payment-cancel-page"
            className="mx-auto max-w-2xl px-4 py-24 sm:px-6 lg:px-8"
        >
            <div className="card-surface p-10 text-center">
                <XCircle className="mx-auto h-10 w-10 text-slate-400" />
                <h1 className="mt-4 font-display text-3xl font-extrabold text-[color:var(--brand-navy)]">
                    Payment canceled
                </h1>
                <p className="mt-3 text-slate-600">
                    No charge was made. Your dates are released. Ready to try
                    again?
                </p>
                <div className="mt-8 flex justify-center gap-3">
                    <Link
                        to="/scooters/pride-victory-10"
                        data-testid="cancel-retry-link"
                        className="hero-cta pill-btn text-white"
                    >
                        Back to booking
                    </Link>
                    <Link
                        to="/"
                        data-testid="cancel-home-link"
                        className="pill-btn border border-slate-200 bg-white text-[color:var(--brand-navy)]"
                    >
                        Return home
                    </Link>
                </div>
            </div>
        </div>
    );
}
